import * as Yup from "yup";

// const companyValidationSchema = Yup.object().shape({

//   name: Yup.string().required().max(100),
//   email: Yup.string().email().required(),
//   orderId: Yup.string().when("$appCode", {
//     is: (appCode: string) => appCode === "xero",
//     then: (schema) => schema.required("Order number is required"),
//     otherwise: (schema) => schema.notRequired(),
//   }),
//   company_settings: Yup.object().shape({
//     date: Yup.date().required("date is required"),
//   }),
//   contact_person: Yup.array().of(
//     Yup.object().shape({
//       designation: Yup.string().required().max(100).required("designation is required"),
//       name: Yup.string().required().max(100).required("name is required"),
//       mobileNo: Yup.string().required().required("mobileNo is required"),
//       email: Yup.string().email().required().required("email is required"),
//     })
//   ),
// });
// export { companyValidationSchema };

export const companyValidationSchema = (appCode?: string) => Yup.object().shape({

  name: Yup.string().required().max(100),
  email: Yup.string().email().required(),
  company_settings: Yup.object().shape({
    orderId: appCode === "xero" ? Yup.string().required("Order number is required") : Yup.string().notRequired(),
    date: Yup.date().required("date is required"),
    tally_migration_start_date: Yup.date().nullable().when("tally_migration", {
      is: true,
      then: (schema) => schema.required("Tally Migration Period Start date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    tally_migration_end_date: Yup.date().nullable().when("tally_migration", {
      is: true,
      then: (schema) =>
        schema
          .required("Tally Migration Period End date is required")
          .min(Yup.ref("tally_migration_start_date"), "End date cannot be before start date"),
      otherwise: (schema) => schema.notRequired(),
    }),
    tally_company_name: Yup.string().when("tally_migration", {
      is: true,
      then: (schema) => schema.required("Company name in Tally is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    tally_serial_no: Yup.string().when("tally_migration", {
      is: true,
      then: (schema) => schema.required("Tally serial no is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }), 
  contact_person: Yup.array().of(
    Yup.object().shape({
      designation: Yup.string().required().max(100).required("designation is required"),
      name: Yup.string().required().max(100).required("name is required"),
      mobileNo: Yup.string().required().required("mobileNo is required"),
      email: Yup.string().email().required().required("email is required"),
    })
  ),
});